import { render, staticRenderFns } from "./BtnWhatsApp.vue?vue&type=template&id=4a443f37&"
import script from "./BtnWhatsApp.vue?vue&type=script&lang=js&"
export * from "./BtnWhatsApp.vue?vue&type=script&lang=js&"
import style0 from "./BtnWhatsApp.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports